import React, { Suspense, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, Theme, Toolbar, withStyles, WithStyles } from '@material-ui/core';
import { ContentLoaderListItem, ErrorBoundary, TextFieldSearch } from 'embeds/components';
import { times } from 'lodash';

import useDimensions from 'hooks/useDimensions';

import QueryListChatActivityAssignees, { QueryListChatActivityAssigneesProps } from './QueryListChatActivityAssignees';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    toolbar: {
      paddingLeft: unit * 2,
      paddingRight: unit * 2,
    },
    infiniteScrollWrapper: {
      flex: 1,
      minHeight: 280,
      maxHeight: 320,
      overflow: 'auto',
    },
  });

const messages = defineMessages({
  search: {
    id: 'deprecated.queries.FilterChatActivityAssignees.search',
    defaultMessage: 'Find an assignee or group',
  },
});

export interface FilterChatActivityAssigneesProps
  extends Omit<QueryListChatActivityAssigneesProps, 'classes'>,
    WithStyles<typeof styles> {
  variables?: Record<string, unknown>;
}

const FilterChatActivityAssignees: React.FC<FilterChatActivityAssigneesProps> = ({ classes, variables, ...rest }) => {
  const [query, setQuery] = useState('');
  const { formatMessage } = useIntl();
  const targetRef = useRef<any>();
  const dimensions = useDimensions(targetRef);

  return (
    <>
      <Toolbar className={classes.toolbar}>
        <TextFieldSearch
          placeholder={formatMessage(messages.search)}
          autoFocus
          fullWidth
          size="small"
          value={query}
          onChange={setQuery}
          InputProps={{ 'data-lh-id': 'patient-actions-activity-reassign-assignee-search' }}
        />
      </Toolbar>
      <div ref={targetRef} className={classes.infiniteScrollWrapper}>
        <ErrorBoundary>
          <Suspense
            fallback={times(15, (i) => (
              <ContentLoaderListItem width={dimensions.width} includeCheckbox includeAvatar key={i} />
            ))}
          >
            <QueryListChatActivityAssignees
              disablePadding
              dense
              variables={{
                ...variables,
                regex: query && `(?i)${query}`,
              }}
              {...rest}
            />
          </Suspense>
        </ErrorBoundary>
      </div>
    </>
  );
};

export default withStyles(styles)(FilterChatActivityAssignees);
